import type { Link } from "types/link/Link";

import { useMemo } from "react";

import BgGradient from "assets/misc/gradient-bg.png";

export const useBackgroundStyles = (
  link: Link | null | undefined,
  brandColor: string | undefined,
) => {
  return useMemo(() => {
    // If link is not loaded yet OR platform is not set, default to gradient/unset
    // This prevents brandColor from flashing before we know if it's Shopify
    if (!link || !link.platform) {
      return {
        backgroundImage: "unset",
        backgroundColor: "unset",
      };
    }

    const isShopifyLink = link.platform === "shopify";

    // Shopify links ALWAYS get white - check this FIRST
    // This prevents any brandColor from being used for Shopify links
    if (isShopifyLink) {
      return {
        backgroundImage: "unset",
        backgroundColor: "#ffffff",
      };
    }

    // Only use brandColor for non-Shopify links
    const backgroundImage = brandColor ? "unset" : `url(${BgGradient})`;
    const backgroundColor = brandColor ? brandColor : "unset";

    return {
      backgroundImage,
      backgroundColor,
    };
  }, [link, link?.platform, brandColor]);
};
